import { render, staticRenderFns } from "./cerrar_session.vue?vue&type=template&id=3057aaf8&scoped=true&"
import script from "./cerrar_session.vue?vue&type=script&lang=ts&"
export * from "./cerrar_session.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3057aaf8",
  null
  
)

export default component.exports